var visited_pages = new Array();

// change placeholder for seach form on homepage banner
$(document).ready(function() {
    if($('.banner-home').length) {
        var default_placeholder = $('.banner-home input[type=text]').attr('placeholder');
        var mobile_placeholder = $('.banner-home input[type=text]').attr('data-mobile-placeholder');
        $(window).resize(function() {
            if ($(window).width() < 768) {
                $('.banner-home input[type=text]').attr('placeholder', mobile_placeholder);
            }else{
                $('.banner-home input[type=text]').attr('placeholder', default_placeholder);
            }
        }).resize();
    }
});

$(document).on('click', '.scroll-to', function(e) {
    e.preventDefault();
    var id = $(this).attr('href');
    var $id = $(id);
    if ($id.length === 0) {
        return;
    }
    var pos = $id.offset().top;
    $('body, html').animate({scrollTop: pos - 110});
});

$('.select-picker-nav li').on('click', function (e) {
    var attr = $(this).attr('data-original-index');
    $('.nav-select li a').eq(attr).tab('show');
});



$(document).ready(function(){
    if($(".nav-select").length) {
        $(".nav-select .nav-tabs a").click(function() {
            var position = $(this).parent().position();
            var width = $(this).parent().outerWidth();
            $(".hline .slider").css({"left":+ position.left,"width":width});

            if ( !$('.sample-questions').length ) {
                index = $(".nav-tabs li").index($(this).parent());
                if (index==0) { by = '/'}
                if (index==1) { by = '?by=topic'}
                if (index==2) { by = '?by=profession'}
            }
            else {
                index = $(".nav-tabs li").index($(this).parent()) + 1;
                total_q = Number($(".nav-tabs li").length);

                if (index!=total_q) {
                    by = "?question/" + index;
                }
                else {
                    by="?results";
                }

            }

            // var stateObj = { foo: "tab" };
            // history.pushState(stateObj, "", by);
            // visited_pages.push(by);

            History.pushState(null, null, by);
        });
        $(window).resize(function() {
          $(".nav-select .nav-tabs a").each(function() {
              $(this).parent().removeAttr("style");
              var width = $(this).outerWidth();
              $(this).parent().width(width+4);
          });
        }).resize();

        var actWidth = $(".nav-tabs .active").outerWidth();
        var actPosition = $(".nav-tabs .active").position();
        $(".hline .slider").css({"left":+ actPosition.left,"width": actWidth});
    }
    if($(".max-mega-menu").length) {
        $(".max-mega-menu > ul > li > a").click(function() {
            var position = $(this).parent().position();
            var width = $(this).parent().outerWidth();
            $(".horizontal-line .slider").css({"left":+ position.left,"width":width});
        });
        var actWidth = $(".max-mega-menu > ul > li.active").outerWidth();
        var actPosition = $(".max-mega-menu > ul > li.active").position();
        $(".horizontal-line .slider").css({"left":+ actPosition.left,"width": actWidth});
    }

    /* close menu if click outside */
    $(document).click(function(event) {
        if(!$(event.target).closest('.max-mega-menu').length) {
            if($('.max-mega-dd').is(":visible")) {
                $('.max-mega-dd').removeClass('on');
                $(".horizontal-line .slider").css({"width": 0});
            }
        }
    });
    $(".max-mega-menu > ul > li > a").on('click', function(e){
      if($(this).parent().find('div').length) {
        e.preventDefault();
        if($(this).parent().find('.max-mega-dd.on').length){
          $('.max-mega-dd').removeClass('on');
        } else {
          $('.max-mega-dd').removeClass('on');
          if($(this).parent().find('.max-mega-dd').length){
            e.preventDefault();
            $(this).parent().find('.max-mega-dd').addClass('on');
          }
        }
      }
    });

    $('.btn-mega-menu').on('click', function(e){
      $(this).parent().toggleClass('on');
      // $(".horizontal-line .slider").css({"width": 0});
    });

    var hoverEnabled = false;

    $(window).resize(function() {
        if ($(window).width() > 768) {
          hoverEnabled = true;
        } else {
          hoverEnabled = false;
        }
    }).resize();

    $(".max-mega-menu > ul > li > a").on('click', function(e){
        if(hoverEnabled == true) {
          if($(this).parent().find('div').length) {

          } else {
              $('.max-mega-dd').removeClass('on');
          }
        }
      });
      $('.max-mega-menu > ul > li > a').on('mouseenter',function(){
          if(hoverEnabled == true) {
              $(this).click();
          }
      });
      $('.max-mega-menu, .max-mega-dd').on('mouseleave',function(){
          if(hoverEnabled == true) {
            setTimeout(function(){
                $('.max-mega-dd').removeClass('on');
                var actWidth = $(".max-mega-menu > ul > li.active").outerWidth();
                var actPosition = $(".max-mega-menu > ul > li.active").position();
                $(".horizontal-line .slider").css({"left":+ actPosition.left,"width": actWidth});
            },200);
          }
      });

    /* blog title and arrow hover */
    // $('.blog .article-box').on('click', function(){
    //       var href = $(this).find('.top').find('a').attr("href");
    //       location.href = href;
    //   });
    // $('.blog .article-box').on('mouseenter',function(){
    //     if(hoverEnabled == true) {
    //         $(this).addClass('active-link');
    //     }
    // });
    // $('.blog .article-box').on('mouseleave',function(){
    //     if(hoverEnabled == true) {
    //         $(this).removeClass('active-link');
    //     }
    // });
});

(function($){

  jQuery.fn.cols = function(num_columns,class_name) {

    //Break up the array into managable chunks
    function chunk (arr, number_of_chunks) {

     var chunks = [],
         i = 0,
         n = arr.length;

     closest_divisible_num = n
     while (closest_divisible_num % 2 != 0) {
       closest_divisible_num++
     }

     chunk_size = closest_divisible_num / number_of_chunks

     while (i < n) {
       chunks.push(arr.slice(i, i += chunk_size));
     }

     return chunks;
    }

    // Turns an array list of UL elements into html
    function createHTML(list){
       html = '';
       for (var i = 0; i < list.length; i++) {
           html += '<li>' + list[i] + '</li>'
       };
       return html
    }

    //Iterate through each match and apply
    $(this).each(function () {

      //Get the current class, so we can add it
      //to the new ULs we will create.
      //cur_class = $(this).attr('class')
      cur_class = class_name;
      if (cur_class == undefined) {
        cur_class = ""
      } else {
        cur_class = "class='" + cur_class + "' "
      }

      //Create array of all posts in lists
      var li_arr = new Array();
      $(this).find('li').each(function(){
         li_arr.push($(this).html());
      })

      //add the HTML back to the dom tree
      array_chunks = chunk(li_arr, num_columns);
      new_html = ""  //html(createHTML(array_chunks[0]));
      for (i = 0; i < num_columns ;i++) {
       new_html = new_html + '<ul ' + cur_class + '>' + createHTML(array_chunks[i]) + '</ul>';
      }
      $(this).replaceWith(new_html)
    });

  };
})(jQuery);

function breakList(numOfLists, list){
    var listLength = list.find("li").size();
    var numInRow = Math.round(listLength / numOfLists);
    for (var i=0;i<numOfLists;i++){
        var listItems = list.find("li").slice(0, numInRow);
        var newList = $('<ul class="col-xs-4"><ul/>').append(listItems);
        list.parent().append(newList);
    }
    list.remove();
}
if($('.three-cols').length) {
    $('.three-cols').each(function(){
        //breakList(3, $(this));
        $(this).cols(3,'col-xs-4');
    });
}
if($('.four-cols').length) {
    $('.four-cols').each(function(){
      if($(this).children().length > 3) {
        $(this).cols(4,'col-xs-3');
      }
    });
}

// collapse categs */
$(document).on('click', '.btn-dd', function(e) {
    e.preventDefault();
    var tab = $(this).parent();
    if(!tab.hasClass('in')){
        $(this).closest('.tab-content').find('.tab-pane').removeClass('in active m-active');
        tab.addClass('in active m-active');
    } else {
        $(this).closest('.tab-content').find('.tab-pane').removeClass('in active m-active');
    }
});

// collapse sub categs */
var clicked = false;
$(document).on('click', '.listing-all div > a', function(e) {
    e.preventDefault();
    var tab = $(this).parent();
    if (!clicked){
        if(!tab.hasClass('in')){
            clicked = true;
            $(this).closest('.row').find('div').removeClass('in');
            setTimeout(function(){
                tab.addClass('in');
            },550);
        } else {
            $(this).closest('.row').find('div').removeClass('in');
        }
        setTimeout(function(){ clicked = false; }, 600);
    }
});

$(document).on('click', '.sample-questions form ul > li > a', function(e) {
    e.preventDefault();
    var tab = $(this).parent();
    if (!clicked){
        if(!tab.hasClass('in')){
            clicked = true;
            $('li.in').removeClass('in');
            setTimeout(function(){
                tab.addClass('in');
            },550);
        } else {
            $(this).parent().removeClass('in');
        }
        setTimeout(function(){ clicked = false; }, 600);
    }
});

$(document).on('click', '.filters.toggle ul li h5', function(e) {
    e.preventDefault();
    var elem = $(this).parent();
    if (!clicked){
        if(!elem.hasClass('on')){
            clicked = true;
            $('li.on').removeClass('on');
            setTimeout(function(){
                elem.addClass('on');
            },250);
        } else {
            $(this).parent().removeClass('on');
        }
        setTimeout(function(){ clicked = false; }, 600);
    }
});

$('.share-dropdown').on('changed.bs.select', function (e) {
    var share_type = $(this).val();
    var subject = $(this).attr('data-subject');
    share(share_type, subject);
    $('.share-dropdown').val('share');
    $('.share-dropdown').selectpicker("refresh");
});

/* show less/more text */
function htmlSubstring(s, n) {
    var m, r = /<([^>\s]*)[^>]*>/g,
        stack = [],
        lasti = 0,
        result = '';

    //for each tag, while we don't have enough characters
    while ((m = r.exec(s)) && n) {
        //get the text substring between the last tag and this one
        var temp = s.substring(lasti, m.index).substr(0, n);
        //append to the result and count the number of characters added
        result += temp;
        n -= temp.length;
        lasti = r.lastIndex;

        if (n) {
            result += m[0];
            if(m[1]!='br') {
              if (m[1].indexOf('/') === 0) {
                  //if this is a closing tag, than pop the stack (does not account for bad html)
                  stack.pop();
              } else if (m[1].lastIndexOf('/') !== m[1].length - 1) {
                  //if this is not a self closing tag than push it in the stack
                  stack.push(m[1]);
              }
            }
        }
    }

    //add the remainder of the string, if needed (there are no more tags in here)
    result += s.substr(lasti, n) + '<span class="moreellipses">...</span>';

    //fix the unclosed tags
    while (stack.length) {
        result +=  '</' + stack.pop() + '>';
    }

    return result;

}
function getRows(selector) {
    var height = $(selector).height();
    var line_height = $(selector).css('line-height');
    line_height = parseFloat(line_height)
    var rows = height / line_height;
    return Math.round(rows);
}
$(document).ready(function() {
    var showChar = 150;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "<span>More details</span> <i class='material-icons'>keyboard_arrow_down</i>";
    var lesstext = "<span>Fewer details</span> <i class='material-icons'>keyboard_arrow_up</i>";

    if($('.more').length){
        $('.more').each(function() {
            var content = $(this).html();
            var content_text = $(this).text();

            // alert(content_text.length);

            //if(content_text.length > showChar) {

                //var c = content.substr(0, showChar);
                var c = htmlSubstring(content, showChar);
                var h = $(this).html();

                var html = '<div class="visible">' + c + '</div><span class="morecontent"><div style="display: none;">' + h + '</div>';
                var html_button = '<a class="btn btn-link morelink hidden-xs">' + moretext + '</a>';
                var html_button_mobile = '<a class="btn btn-link morelink visible-xs text-left">' + moretext + '</a>';

                $(this).html(html);
                $(this).parents('.content').append(html_button_mobile);
                $(this).parents('.content').find('.left .more').after(html_button);
            //}
            var h_row = getRows($(this).find('.visible'));
            if(h_row > 4){
              $(this).css('max-height','1000px')
            }
        });
    }

    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parents('.content').toggleClass('more');
        return false;
    });

    // filter btn
    $('.btn-filter').on('click', function(e){
        e.preventDefault();
        $('body').toggleClass('filter-popup');
    });
    $('.close-filters').on('click', function(e){
        $('body').removeClass('filter-popup');
    });


    /* Manual show and hide toggle for category descriptions */
    $(document).ready(function() {
        var catlesstext = "<span>Show less</span> <i class='material-icons'>keyboard_arrow_up</i>";
        var catmoretext = "<span>Show more</span> <i class='material-icons'>keyboard_arrow_down</i>";

        $(".catshowmore").click(function(e) {
        e.preventDefault();
        $(".long-description .expand").toggleClass("hide");

            if($(this).hasClass("catmoretext")) {
                $(this).toggleClass("catmoretext");
                $(this).toggleClass("catlesstext");
                $(this).html(catlesstext);
            } 

            else {
                $(this).toggleClass("catlesstext");
                $(this).toggleClass("catmoretext");
                $(this).html(catmoretext);
            }
        });
    });

    /* blog categories - move h3 */
    if($('.move-screens').length){
      $(window).resize(function() {
          if ($(window).width() < 768) {
              $('.move-screens').insertBefore('.container-mobile-dd');
          }else{
              $('.move-screens').insertBefore('.listing-articles');
          }
      }).resize();
    }

    if($('.sample-questions').length) {
      var questions_no = $('.nav-select .nav-tabs li').size()-1;
      $(".tab-content > .tab-pane:nth-child("+questions_no+")").find('.next-question-desktop').find('span').text('Show Results');
    }
    $('.sample-questions .answers li').on('click', function(){
      $(this).closest('.answers').addClass('hidden');
      $(this).closest('.answers').next().removeClass('hidden');
    });
    $('body').on('click','.sample-questions .nav-select .nav-tabs li:not(.disabled)', function(){
      $('.current-question').text($(this).index()+1);
    });
    // next question - sample questions
    $('.next-question-desktop').click(function(e){
      e.preventDefault();
      $('.nav-tabs > .active').removeClass('disabled');
      $('.nav-tabs > .active').next('li').removeClass('disabled');
      $('.nav-tabs > .active').next('li').find('a').trigger('click');
      $('.current-question').text($('.nav-tabs > .active').index()+1);
      $('html, body').animate({
        scrollTop: $(".main-content").offset().top - 120
      }, 500);

      index = $('.nav-tabs > .active').index() + 1;
      total_q = Number($(".nav-tabs li").length);
      
      if (index!=total_q) {
          by = "?question/" + index;
      }
      else {
          by="?results";
      }


      History.pushState(null, null, by);

      return false;
    });
    // mobile
    $('.next-question').click(function(e){
      e.preventDefault();
      $('.nav-tabs > .active').next('li').find('a').trigger('click');
      $('.current-question').text($('.nav-tabs > .active').index()+1);
    });
    $('.total-questions').text($('.tab-pane').size());

    /* active class when choose and answer - sample question page */
    $('.sample-questions .answers li').on('click', function(){
      $('.sample-questions .answers li').removeClass('active');
      $(this).addClass('active');
    });

    /* subscribe form */
    function validateEmail(emailAddress) {
        var pattern = new RegExp(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i);
        return pattern.test(emailAddress);
    }

    // $('.stay-up-to-date form button').on('click', function(e){
    //   e.preventDefault();

    //   var email_address = $('#email').val();
    //   var data = {email: email_address};
    //   if( !validateEmail(email_address)) {
    //     $('#email').addClass('error');
    //   } else {
    //     $('#email').removeClass('error');
    //     // send email
    //     $.ajax({
    //         type: "POST",
    //         url: "subscribe.php",
    //         data: data,
    //         beforeSend: function() {
    //             $(".stay-up-to-date form .input-group button i").text('cached').addClass('rotating');
    //         },
    //         success: function(){
    //             $(".stay-up-to-date form .input-group button i").text('chevron_right').removeClass('rotating');
    //             $('.stay-up-to-date').addClass('response-visible');
    //             $('.stay-up-to-date .col-xs-12').append('<div class="response-form"><h2>Thank your for your subscription.</h2></div>');
    //         }
    //     });
    //   }
    // });

    // Signup form submission
    $('#pfb-signup-submission, #pfb-signup-submission-front').submit(function(event) {
      event.preventDefault();
      var form_name = $(this).attr('id');
      var wrapper_div_str = ".form-wrapper" + (form_name.endsWith("-front") ? "-front" : "");

      var email_address_input = $('#' + form_name + ' input[type="email"]');
      if( !validateEmail(email_address_input.val())) {
        email_address_input.addClass('error');
      } else {
        // Create JSON variable of retreived data
        var pfbSignupData = {
          'firstname': '',
          'lastname': '',
          'email': email_address_input.val(),
          'zipcode': ''
        };

        // Send data to PHP script via .ajax() of jQuery
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: theme_path + '/mailchimp-signup.php',
          data: pfbSignupData,
          beforeSend: function() {
            $(wrapper_div_str + " form .input-group button i").text('cached').addClass('rotating');
          },
          success: function (results) {
            $(wrapper_div_str + " form .input-group button i").text('chevron_right').removeClass('rotating');
            $(wrapper_div_str).addClass('response-visible');
            if (results.response == 200) { /* success */
                $(wrapper_div_str + ' .col-xs-12').append('<div class="response-form"><h2>Thank you for your subscription.</h2></div>');
            } else {
                $(wrapper_div_str + ' .col-xs-12').append('<div class="response-form"><h2>Sorry but we were unable to add you to the email list.</h2></div>');
            }
          },
          error: function (results) {
            $(wrapper_div_str + " form .input-group button i").text('chevron_right').removeClass('rotating');
            $(wrapper_div_str).addClass('response-visible');
            $(wrapper_div_str + ' .col-xs-12').append('<div class="response-form"><h2>Sorry but we were unable to add you to the email list.</h2></div>');
          }
        });
      }
    });
    
    /* results form */
    $('.results-form form button').on('click', function(event){
      event.preventDefault();

      var email_address = $('#email_address').val();
      var data = {email: email_address};
      if( !validateEmail(email_address)) {
        $('#email_address').addClass('error');
      } else {
        // Get data from form and store it
        var pfbSignupFNAME = '';
        var pfbSignupLNAME = '';
        var pfbSignupEMAIL = $('#email_address').val();
        var pfbSignupZIP = '';

        // Create JSON variable of retreived data
        var pfbSignupData = {
          'firstname': pfbSignupFNAME,
          'lastname': pfbSignupLNAME,
          'email': pfbSignupEMAIL,
          'zipcode': pfbSignupZIP
        };

        // Send data to PHP script via .ajax() of jQuery
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: theme_path + '/mailchimp-signup.php',
          data: pfbSignupData,
          beforeSend: function() {
              $(".results-form form .input-group button i").text('cached').addClass('rotating');
          },
          success: function(){
              $(".results-form form .input-group button i").text('chevron_right').removeClass('rotating');
              $('.results-form').addClass('hidden');
              $('.score').removeClass('hidden');
          }
        });
      }


    });




// impressions tracking

	const onScrollStop = callback => {
		let isScrolling;
		window.addEventListener('scroll', e => {
			clearTimeout(isScrolling);
			isScrolling = setTimeout(() => { callback(); }, 20);
		}, false);
	}
	onScrollStop(() => {
		var impressions_array = [];
		jQuery("ul.resources-listing li .box .product").not("viewed").each(function(i,e) {
			if (! $(this).hasClass("viewed")) {
				if (elementOnScreen($(this))) {
					impressions_array[impressions_array.length] = {'index' : page_offset + i, 'item_id' : $(this).attr("data-id"), 'item_name' : $(this).attr("data-title") };
					$(this).find("a.view_item").on("click", { item_data: {'index' : page_offset + i, 'item_id' : $(this).attr("data-id"), 'item_name' : $(this).attr("data-title"), 'item_list_id' : ga_list_id } }, sendGAItemView);
					$(this).addClass("viewed");
				}
			}
		});
		if (impressions_array.length) {
			sendGAImpressions(impressions_array);	
		}
	});
    
    function elementOnScreen(elem) {
    	if ( ! elem.length ) return false;
    	var viewport_top = $(window).scrollTop() + $("div.navbar-fixed-top").height();
    	var viewport_bottom = $(window).scrollTop() + $(window).height();
    	var elem_midpoint = $(elem).offset().top + ($(elem).height() / 2);
    	var on_screen = (elem_midpoint < viewport_bottom && elem_midpoint > viewport_top);	
    	return on_screen;
    }
    
    function sendGAItemView(e) {
    	dataLayer.push({
    		event: "select_item",
    		ecommerce: {
    			items: [ e.data.item_data ]
    		}
    	});
    }
    
    function sendGAImpressions(items_array) {
    	if (items_array.length) {
    		dataLayer.push({
    			event: "view_item_list",
    			ecommerce: {
    				item_list_id: ga_list_id,
    				items: items_array
    			}
    		});
    	}
    }
// end impressions tracking



// autocomplete search
  var matches = [];
  if ($('input[name="search"]')) {
    $('input[name="search"]').autoComplete({
        minChars: 1,
    delay: 0,
        source: function(term, suggest){
            term = term.toLowerCase();

      //the choices array is generated in the header
      var matches = [];
            for (i=0; i<choices.length; i++)
                if (~choices[i].toLowerCase().indexOf(term)) matches.push(choices[i]);

            suggest(matches);


        },
    menuClass : 'search_dropdown',
    onSelect: function(event, term, item) {

      // if a suggestion was selected, go ahead and take the user to the page
    //   if (choices.indexOf(term)>=0) {
    //     window.location.href = links[choices.indexOf(term)];
    //   }
    },
    });
  }


  $('input[name="search"]').parents('form').submit(function(){

      if (autoSelectedItem && autoSelectedItem!="No results found") {

          spin = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
          $(this).find('button span').html(spin);
          $(this).find('button i').addClass('rotating');


          window.location.href = links[choices.indexOf( autoSelectedItem )];

      }
      else {
          alert("No results found");
          $(this).parent().find('input').focus();
      }


    return false;
  });



/* Remove jump link on register page desktop size */

if (window.matchMedia("(min-width: 770px)").matches) {
  $('#dashboardregister').removeAttr('id');
}

/* Create progress circles on dashboard page */

var circles = $('.cme-percent-circle');
$.each(circles, function() {
  
  var fromHidden = -90;

  function topAlign(degrees) {
      return degrees - 45
  };

  function rotate(el, degrees) {
    var degrees = topAlign(degrees || 0);
    el.css(
      'transform', 'rotate('+degrees+'deg)',
      '-webkit-transform', 'rotate('+degrees+'deg)',
      '-moz-transform', 'rotate('+degrees+'deg)',
      '-ms-transform', 'rotate('+degrees+'deg)',
      '-o-transform', 'rotate('+degrees+'deg)'
    )
  }

  function circle(el, normalisedValue) {
    var degrees = normalisedValue * 360;
    var counter = 1;
    el.find('.arc_q').each(function(){
      var angle = Math.min(counter * 90, degrees);
      rotate($(this), fromHidden + angle);
      counter++;
    });
    if (degrees > 90) {
      el.find('.arc_cover').css('display', 'none');
    }
  }

  function animate(el, normalisedValue, current) {
    var current = current || 0;
    circle(el, current);
    if (current < normalisedValue) {
      current += 0.01;
      setTimeout(function () { animate(el, normalisedValue, current); }, 1);
    }
  }

var customNum;
  var htmlVal = $(this).find('#tracker_perc').text();
  var floatVal = parseFloat(htmlVal);
  
  if (floatVal < 10) {
    htmlVal = '0' + htmlVal;
    customNum = parseFloat('0.' + htmlVal);
  } else if (floatVal === 100) {
    customNum = 1;
  } else {
    customNum = parseFloat('0.' + htmlVal); 
  }
  
  // kick things off ..
  animate($(this), customNum);
});





// category page events
  $(".category_checkbox").change(function(){
    window.location.href = $(this).data("select");
  });



  if ($(".selection-tags").length>0) {
    $(".selection-tags-mobile").html( $(".selection-tags").html() );
  }
  else {
    $(".selection-tags-mobile").html('');
  }




// Sample cases score and events
  $('.answers li').click(function(){

    the_answer_block = $(this).parent().parent().find('.answer');
    var a_correct = 'incorrect';
    if ( $(this).hasClass('correct_answer') ) {
      the_answer_block.addClass('correct');
      $('.score_li').eq($(this).data('question')).addClass('correct');
      score = parseInt($('.score p span').text()) + 1;
      $('.score p span').html(score);
      a_correct = 'correct';
    }
    else {
      the_answer_block.addClass('incorrect');
      $('.score_li').eq($(this).data('question')).addClass('incorrect');
    }
    $(this).parent().parent().find('.next-question-desktop').attr('href', '#question' + Number($('.nav-tabs > .active').index()+2))
    the_answer_block.show();

    q_index = Number($('.nav-tabs > .active').index() + 1);

    $.cookie('question' + q_index, a_correct);
  });


  if ( $('.sample-questions').length ) {

      url = window.location.href;
      q_number = url.substring( url.indexOf('?question/') + 10 );
      last_q = Number($('.sample-questions .nav-tabs li').length);

      if (url.indexOf('?question/')<=0) { q_number = 1 }
      if (url.indexOf('?results')>=0) { q_number = last_q }


          for (i=0; i<=$('.nav-tabs').length; i++) {

              cook = $.cookie('question' + (i+1));
              if ( typeof cook !== 'undefined' || q_number == last_q) {

                  $('.nav-tabs li').eq(i).removeClass('disabled');
                  the_answers = $('#question' + (i+1)).find('.answers');
                  the_answer_block = $('#question' + (i+1)).find('.answer');

                  if ( cook == 'correct') {
                      the_answer_block.addClass('correct');
                  }
                  else {
                      the_answer_block.addClass('incorrect');
                  }
                  the_answers.addClass('hidden');
                  the_answers.next().removeClass('hidden');
              }
          }


          if ( typeof $.cookie('question' + q_number)!== 'undefined' || q_number == last_q ) {
              $('.nav-tabs li').eq(q_number - 1).removeClass('disabled');
              $('html, body').animate({
                scrollTop: $(".main-content").offset().top - 120
              }, 1);

              $('.nav-tabs li').eq(q_number - 1).find('a').trigger('click');
          }
  }




  // Establish Variables
  var
      State = History.getState(),
      $log = $('#log');

  // Log Initial State
  History.log('initial:', State.data, State.title, State.url);

  // Bind to State Change
  History.Adapter.bind(window,'statechange',function(){ // Note: We are using statechange instead of popstate
      // Log the State
      var State = History.getState(); // Note: We are using History.getState() instead of event.state
      History.log('statechange:', State.data, State.title, State.url);


      if ( $('.sample-questions').length ) {

          url = State.url;
          q_number = url.substring( url.indexOf('?question/') + 10 )
          last_q = Number($('.sample-questions .nav-tabs li').length);
          if (url.indexOf('?question/')<=0) { q_number = 1 }
          if (url.indexOf('?results')>=0) { q_number = last_q }

              for (i=0; i<=$('.nav-tabs').length; i++) {

                  cook = $.cookie('question' + (i+1));
                  if ( typeof cook !== 'undefined' ) {
                      $('.nav-tabs li').eq(i).removeClass('disabled');
                      the_answers = $('#question' + (i+1)).find('.answers');
                      the_answer_block = $('#question' + (i+1)).find('.answer');

                      if ( cook == 'correct') {
                          the_answer_block.addClass('correct');
                      }
                      else {
                          the_answer_block.addClass('incorrect');
                      }
                      the_answers.addClass('hidden');
                      the_answers.next().removeClass('hidden');
                  }
              }



              if ( typeof $.cookie('question' + q_number)!== 'undefined' || q_number == last_q ) {
                  $('.nav-tabs li').eq(q_number - 1).removeClass('disabled');
                  $('html, body').animate({
                    scrollTop: $(".main-content").offset().top - 120
                  }, 1);

                  $('.nav-tabs li').eq(q_number - 1).find('a').trigger('click');
              }

          //$('.nav-tabs li').eq(q_number - 1).find('a').trigger('click');
      }


  });






});
